import React, { useEffect } from "react";
import { useT } from "../../i18n";

export default function DocumentsPage() {
  const t = useT();
  useEffect(() => {
    // Redirect to Notion page immediately
    window.open(
      "https://www.notion.so/hiluxia/Luxia-User-Manual-11a00530bce98032b9f0db4a65ceb3ed",
      "_blank"
    );
  }, []);

  return (
    <div className="flex items-center justify-center h-full bg-gray-50">
      <div className="text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="fa-solid fa-external-link text-blue-600 text-2xl"></i>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {t("documents.title")}
        </h3>
        <p className="text-gray-600">
          {t("documents.subtitle")}
        </p>
      </div>
    </div>
  );
}
